import { render, staticRenderFns } from "./DatasetsPage.vue?vue&type=template&id=13af1227"
import script from "./DatasetsPage.vue?vue&type=script&lang=js"
export * from "./DatasetsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports